import { Location, State } from "history";
import { EnhancedAccount } from "library/accounts/types";
import { FullPersonalDetails } from "pages/ManagePersonalDetails/types";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { basePath, pathNames } from "../constants";

type LocationState = {
  account: EnhancedAccount;
  fullPersonalDetails: FullPersonalDetails;
};

type Options = {
  replace?: boolean | undefined;
  state?: State | undefined;
};

export const useNav = () => {
  // https://github.com/ReactTraining/react-router/issues/7384
  const { state, pathname } = useLocation() as Location<LocationState | null>;

  const routerNavigate = useNavigate();

  useEffect(() => {
    if (!state) {
      routerNavigate(basePath, {
        replace: true,
      });
    }
  }, [state, routerNavigate]);

  const goBack = () => {
    routerNavigate(-1);
  };

  const goHome = () => {
    routerNavigate(`/`);
  };

  const navigate = (path: keyof typeof pathNames, options?: Options) => {
    routerNavigate(`${basePath}${path}`, options);
  };

  return { goBack, goHome, navigate, state, pathname };
};
